// @ts-check
import React from "react";

/** @type { React.Context<GlobalVariables>} */
// @ts-ignore
export const GlobalVariablesContext = React.createContext({setHeader:null,  showAlert: null, showSnackbar: null, showBackdrop: null, hideBackdrop: null});
